import React from 'react';
import { TipoMensagem } from '../interfaces/IAuditoriaEntradaDados';

interface Props {
  type: TipoMensagem;
  title: string;
  message?: string;
  actionLabel?: string;
  onAction?: () => void;
  closable?: boolean;
  onClose?: () => void;
}

const ICONE_POR_TIPO: Record<TipoMensagem, string> = {
  INFO: 'bi-info-circle-fill',
  WARNING: 'bi-exclamation-triangle-fill',
  ALERT: 'bi-exclamation-octagon-fill',
  ERROR: 'bi-x-octagon-fill',
  SUCCESS: 'bi-check-circle-fill',
};

const CLASSE_POR_TIPO: Record<TipoMensagem, string> = {
  INFO: 'audit-message-info',
  WARNING: 'audit-message-warning',
  ALERT: 'audit-message-alert',
  ERROR: 'audit-message-error',
  SUCCESS: 'audit-message-success',
};

// Componente padrão de mensagens da Central de Entrada de Dados (Épico "Mensagens, Feedbacks e
// Gestão de Arquivos", seção 7 — `AuditMessage`). Usado para INFO/WARNING/ALERT/ERROR/SUCCESS
// em qualquer ponto do fluxo (campo obrigatório, validação, upload, processamento).
const AuditMessage: React.FC<Props> = ({ type, title, message, actionLabel, onAction, closable, onClose }) => {
  return (
    <div className={`audit-message ${CLASSE_POR_TIPO[type]}`} role={type === 'ERROR' ? 'alert' : 'status'}>
      <i className={`bi ${ICONE_POR_TIPO[type]} audit-message-icon`} />
      <div className='audit-message-body'>
        <div className='audit-message-title'>{title}</div>
        {message && <div className='audit-message-text'>{message}</div>}
        {actionLabel && onAction && (
          <button type='button' className='btn btn-sm audit-message-action' onClick={onAction}>
            {actionLabel}
          </button>
        )}
      </div>
      {closable && (
        <button type='button' className='btn-close audit-message-close' aria-label='Fechar' onClick={onClose} />
      )}
    </div>
  );
};

export default AuditMessage;
